"use client"

import {Chip} from "@mui/material";
import React from "react";
import {useAppStore} from "@/store/AppStore";
import {useTranslations} from "use-intl";

export default function LoginAlert() {
  const t = useTranslations("Main")
  const setLoginPopup = useAppStore((state) => state.setLoginPopup);

  return <div style={{margin: "2rem 0"}}><Chip color={"secondary"} variant={"filled"} label={t("must_login")}
                                               onClick={() => {
                                                 setLoginPopup(true)
                                               }}/></div>
}
